/**
 * First-touch attribution for calculator records (brief 02 'Storage': source_path + utm_*).
 * UTMs usually arrive on a landing page, not on /estimate-calculator, so we capture them once per
 * browser session on the first page view and hand them to the estimate POSTs later.
 */
const KEY = 'idb_attribution';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    UTM_KEYS.forEach((k) => { const v = params.get(k); if (v) utm[k] = v.slice(0, 200); });
    const existing = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (existing && Object.keys(utm).length === 0) return existing; // keep first touch
    const record = {
      utm: Object.keys(utm).length ? utm : (existing?.utm || {}),
      landing_path: existing?.landing_path || window.location.pathname,
      referrer: existing?.referrer || document.referrer || '',
    };
    sessionStorage.setItem(KEY, JSON.stringify(record));
    return record;
  } catch (e) {
    return { utm: {}, landing_path: '', referrer: '' };
  }
}

export function getAttribution() {
  try {
    const rec = JSON.parse(sessionStorage.getItem(KEY) || 'null') || captureAttribution();
    return { source_path: window.location.pathname, utm: rec.utm || {}, landing_path: rec.landing_path || '' };
  } catch (e) {
    return { source_path: typeof window !== 'undefined' ? window.location.pathname : '/estimate-calculator', utm: {}, landing_path: '' };
  }
}
